// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CustomNavigation_arrow__jo_GE"};